// 한국 지역 데이터 구조
// 광역시는 그대로, 도 단위는 하위 시 선택 가능

export interface RegionOption {
  value: string;
  label: string;
  cities?: string[]; // 도 단위인 경우 하위 시 목록
}

// 광역시 목록
const METROPOLITAN_CITIES = [
  "서울특별시",
  "부산광역시",
  "대구광역시",
  "인천광역시",
  "광주광역시",
  "대전광역시",
  "울산광역시",
  "세종특별자치시",
];

// 도 단위 지역의 주요 시 목록 (군/구 제외, 시만 포함)
const PROVINCE_CITIES: Record<string, string[]> = {
  경기도: [
    "수원시",
    "성남시",
    "고양시",
    "용인시",
    "부천시",
    "안산시",
    "안양시",
    "남양주시",
    "화성시",
    "평택시",
    "의정부시",
    "시흥시",
    "김포시",
    "광명시",
    "광주시",
    "군포시",
    "하남시",
    "오산시",
    "이천시",
    "구리시",
    "안성시",
    "포천시",
    "의왕시",
    "양주시",
    "동두천시",
    "과천시",
    "여주시",
  ],
  강원도: [
    "춘천시",
    "원주시",
    "강릉시",
    "동해시",
    "태백시",
    "속초시",
    "삼척시",
  ],
  충청북도: [
    "청주시",
    "충주시",
    "제천시",
  ],
  충청남도: [
    "천안시",
    "공주시",
    "보령시",
    "아산시",
    "서산시",
    "논산시",
    "계룡시",
    "당진시",
  ],
  전라북도: [
    "전주시",
    "군산시",
    "익산시",
    "정읍시",
    "남원시",
    "김제시",
  ],
  전라남도: [
    "목포시",
    "여수시",
    "순천시",
    "나주시",
    "광양시",
  ],
  경상북도: [
    "포항시",
    "경주시",
    "김천시",
    "안동시",
    "구미시",
    "영주시",
    "영천시",
    "상주시",
    "문경시",
    "경산시",
  ],
  경상남도: [
    "창원시",
    "진주시",
    "통영시",
    "사천시",
    "김해시",
    "밀양시",
    "거제시",
    "양산시",
  ],
  제주특별자치도: ["제주시", "서귀포시"],
};

// 전체 지역 목록 생성
export const KOREAN_REGIONS_DETAILED: RegionOption[] = [
  // 광역시
  ...METROPOLITAN_CITIES.map(city => ({
    value: city,
    label: city,
  })),
  // 도 단위 (하위 시 포함)
  ...Object.entries(PROVINCE_CITIES).map(([province, cities]) => ({
    value: province,
    label: province,
    cities: cities,
  })),
];

// 지역 값 파싱 (예: "경기도 > 수원시" -> { province: "경기도", city: "수원시" })
export function parseRegion(regionValue: string): {
  province: string;
  city?: string;
} {
  if (regionValue.includes(" > ")) {
    const [province, city] = regionValue.split(" > ");
    return { province, city };
  }
  return { province: regionValue };
}

// 지역 값 생성 (예: { province: "경기도", city: "수원시" } -> "경기도 > 수원시")
export function formatRegion(province: string, city?: string): string {
  if (city) {
    return `${province} > ${city}`;
  }
  return province;
}

